import React from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../../../convex/_generated/api';
import BundleCard, { BundleCardData } from '../BundleCard';
import { ViewAllButton } from '../../ui/view-all-button';
import { useLanguage } from '../../../contexts/useLanguage';
import { WebCatalogUpdatingNotice } from '../WebCatalogUpdatingNotice';
import { HomeProductRail } from './HomeProductRail';

const HomeBundles: React.FC = () => {
  const { t } = useLanguage();
  const bundles = (useQuery(api.packages.listAvailable) ?? []) as BundleCardData[];

  return (
    <section id="bundles" className="home-product-type-section bg-[#f7f2ed]">
      <div className="mx-auto mb-6 w-full max-w-7xl px-4 sm:px-6 lg:px-8 md:mb-8">
        <div className="text-center">
          <h2 className="font-felix-titling mb-2 text-3xl font-bold text-[#3d2817] md:text-4xl">
            {t('landing.packages.title') || 'Bundles'}
          </h2>
          <p className="font-felix-titling mx-auto max-w-2xl truncate overflow-hidden text-ellipsis whitespace-nowrap text-xl text-gray-600">
            {t('landing.packages.subtitle') || 'Manager-created bundles are now visible here in real time.'}
          </p>
          <div className="mt-5 flex justify-center">
            <ViewAllButton
              to="/webdesigned/forfaits"
              label={t('landing.packages.viewAll') || 'View all bundles'}
              className="text-sm"
            />
          </div>
        </div>
      </div>

      {bundles.length > 0 ? (
        <HomeProductRail aria-label={t('landing.packages.title') || 'Bundles'}>
          {bundles.map((bundle) => (
            <BundleCard key={bundle._id} bundle={bundle} />
          ))}
        </HomeProductRail>
      ) : (
        <div className="mx-auto max-w-7xl px-4">
          <WebCatalogUpdatingNotice />
        </div>
      )}
    </section>
  );
};

export default HomeBundles;
